import { render, staticRenderFns } from "./Roses.vue?vue&type=template&id=e8e4e868&scoped=true&"
import script from "./Roses.vue?vue&type=script&lang=js&"
export * from "./Roses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e4e868",
  null
  
)

export default component.exports